import { Errors } from '@contracts'

export class FEApiError<T = any> extends Error {
  ok: boolean
  status: number
  errors: Errors[] | null
  fieldOverrideMap?: Map<keyof T, keyof T>

  constructor(props: { ok: boolean; status: number; errors: Errors[] | null; message: string }) {
    super(props.message)
    this.ok = props.ok
    this.status = props.status
    this.errors = props.errors || null
    this.message = props.message
  }

  // getter to dynamically check if the error response is in the validation format
  get isValidationError() {
    return !!this?.errors?.length
  }

  // getter to get the first error message from the response when you need to show a single error message
  get singleErrorMessage() {
    return this.isValidationError ? this.errors![0]?.message : this.message
  }
}
